import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Slider from '@react-native-community/slider';
import { FONT_STYLE } from '../../dataSchema/const';

type LikertBarProps = {
  onSelect?: (value: number) => void;
  defaultAnswer?: { values: string[] } | null;
  startText?: string;
  endText?: string;
};

const LikertBar: React.FC<LikertBarProps> = ({ onSelect, defaultAnswer = null, startText = "", endText = "" }) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (defaultAnswer && defaultAnswer.values && defaultAnswer.values[0]) {
      const valueNum = Number.parseInt(defaultAnswer.values[0]);
      setValue(valueNum);
    }
  }, [defaultAnswer]);

  const handleChange = (val: number) => {
    setValue(val);
    if (onSelect) {
      onSelect(val);
    }
  };

  return (
    <View>
      <View style={styles.container}>
        <Text style={styles.valueText}>
          {value ? `${value < 10 ? `0${value}` : value}` : '00'}
          <Text style={styles.suffixText}>/10</Text>
        </Text>
        <Slider
          style={styles.slider}
          minimumValue={0}
          maximumValue={10}
          step={1}
          minimumTrackTintColor="#F65D79"
          maximumTrackTintColor="#D3D3D3"
          thumbTintColor="#ECECEC"
          value={value}
          onValueChange={handleChange}
          thumbImage={require('../../assets/Thumb.png')}
        />

      </View>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: 300, marginLeft: 50 }}>
        <Text style={styles.firstRowLabel}>{startText}</Text>
        <Text style={styles.secondRowLabel}>{endText}</Text>
      </View>
    </View>

  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  slider: {
    width: 300,
    height: 40,
    marginLeft: 10,
    marginRight: 10,
  },
  valueText: {
    fontFamily: 'System',
    fontSize: 14,
    color: '#F65D79',
  },
  suffixText: {
    fontSize: 14,
    fontFamily: 'System',
    color: '#000000',
  },
  firstRowLabel: {
    marginLeft: 4,
    color: '#FF4C4D',
    textAlign: 'left',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
  secondRowLabel: {
    marginRight: 4,
    color: '#0DC98B',
    textAlign: 'right',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
});

export default LikertBar;